export default __webpack_public_path__ + "static/media/image-jeremy.71cd41f1.png";